import React, { useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { NavList, NavItem } from 'components/composite';
import { COM_TAB_MAP_ID } from 'constants/travelsafe';
import { Badge, Spacer } from '@cleartrip/bento';

import { TabContext } from 'context/travelsafe';
import Clevertap from 'analytics'
function TabsDom({tabChangeHandler = () => {}}) {
	let query = new URLSearchParams(window.location.search);
	let history = useHistory()

	let [tab, setTab] = useContext(TabContext)

	useEffect(()=> {
		let tabQuery = query.get('navtab')
		if(tabQuery)
			setTab(tabQuery.toUpperCase())
	},[query,setTab])

	function setTabHandler(tabId) {
		Clevertap.event('Air_UI_action', {
			action_name: tabId === "INT" ? 'international_tab':'domestic_tab',
		})
    tabChangeHandler()
		query.set('navtab', tabId);
    query.set('from', '');
    query.set('to', '');
		history.push({search: '?' + query.toString()});
		setTab(tabId)
	}

	return (
		<NavList>
			<NavItem
				active={tab === COM_TAB_MAP_ID.DOM_TRAVEL}
				className='fs-3 fs-3--xs h-9 t-all h-7--xs'
				onClick={() => setTabHandler(COM_TAB_MAP_ID.DOM_TRAVEL)}
			>
				Travel within India
			</NavItem>
			<Spacer className="pr-10 pr-6--xs" />
			<NavItem
				active={tab === COM_TAB_MAP_ID.INT_TRAVEL}
				className='fs-3 fs-3--xs h-9 t-all h-7--xs'
				onClick={() => setTabHandler(COM_TAB_MAP_ID.INT_TRAVEL)}
			>
				International travel
				{/* <Spacer className='mr-2' />
				<Badge style={{marginTop: '2px'}} size='sm' type='success'>
					NEW
				</Badge> */}
			</NavItem>
		</NavList>
	);
}

export default TabsDom;
